import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    padding: 16px;
  }
`

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  max-width: 560px;
  text-align: center;
`

export const CardsGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
  max-width: 1080px;
  margin-bottom: 32px;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border: 1px solid ${props => props.theme.colors.greys.border};
  border-radius: 12px;
  width: 360px;

  		@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: auto;
		height: auto;
	}
`

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    width: 100%;
  }
`

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 999px;
  background: ${props =>
    props.$variant === 'error'
      ? props.theme.colors.feedback.errorLight
      : props.theme.colors.feedback.successLight};
  color: ${props =>
    props.$variant === 'error'
      ? props.theme.colors.feedback.error
      : props.theme.colors.feedback.success};
`

export const LinkButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  color: ${props => props.theme.colors.brand.blueOmint};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: underline;
  width: fit-content;
`
